import { render, staticRenderFns } from "./void.vue?vue&type=template&id=5c5965da&scoped=true&"
import script from "./void.vue?vue&type=script&lang=js&"
export * from "./void.vue?vue&type=script&lang=js&"
import style0 from "./void.vue?vue&type=style&index=0&id=5c5965da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5965da",
  null
  
)

export default component.exports